import { URL_PREFIX, URL_POSTFIX } from './url';

// 邮箱正则验证
export const emailReg: any =
	/^[A-Za-z\d_-]+([-_.][A-Za-z\d_-]+)*@([A-Za-z\d_-]+[-.])+[A-Za-z\d_-]{2,6}$/;

// 姓名不能全为空
export const nameAllNullReg: RegExp = /^[ ]*$/;

export const nameReg: any = /^.{0,24}$/;

export const passwordReg: any = /^(?:\d|[a-zA-Z]|[~!@#$%^&*()_+<>?:"{},.\/;'[\]]){6,20}$/;

// export const inviteCodeReg: any = /^[a-zA-Z0-9]{6}$/;
export const inviteCodeReg: any = /^.{6}$/;

// 手机号正则
export const phoneNumReg: any = /^1[3456789]\d{9}$/;

// 六位数字正则
export const phoneCodeNumReg: any = /^\d{6}$/;

// url正则字符串
const urlRegText =
	'^((https|http|ftp)://)?' + //(https或http或ftp):// 可有可无
	"(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + //ftp的user@  可有可无
	'(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
	'|' + // 允许IP和DOMAIN（域名）
	'(localhost)|' + //匹配localhost
	"([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
	'\\w+\\-?\\w+\\.' + // 一级域名 -英文或数字，可以有「-」  加上.
	'[a-zA-Z]{1,7})' + // 顶级域名- 1-7位英文
	'(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
	'((/?)|' + // url无参数结尾 - 斜杆或这没有
	"(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$";

// 简单的 url 匹配
export const urlRegex = /^(?:(?:https?|ftp):\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+$/;

// url正则表达式
export const urlReg: any = new RegExp(urlRegText, 'i');

// 8~18(之前的老用户是 9-15)位「字母+数字+加减号」组成，字母开头（不区分大小写)（旧版和在账户设置里手动修改的 ID）
export const userIdReg = /^[a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9_+]{7,17}$/;

export const containsEnglish = /[a-zA-Z]/;

export const emptyRegex = /^[\s\n\t]*$/;

/**
 * @description: Create a regular expression to match URLs based on a given prefix or postfix
 * @param {*} prefix
 * @param {*} postfix
 * @return {*}
 */
let isUrlRegFn = (prefix = 'http|https', postfix = 'com|cn|gov|edu'): RegExp => {
	const urlRegex = `((${prefix})\\:\\/\\/)[^\\s]+|[^\\s]+[\\.](${postfix})\\b`;
	return new RegExp(urlRegex);
};
export let isUrlReg: RegExp = isUrlRegFn(URL_PREFIX.join('|'), URL_POSTFIX.join('|'));
